import React from 'react';

import { DropdownLayout } from "components";

import { func_validation } from 'functions';

import userIcon from 'assets/images/user.svg';

import "assets/scss/billingPortal/modules/accountOverviewDropdown.scss";

export default function AccountOverviewDropdown(props) {
    const { accountOverviewArray, dropdownDetailArray, 
            isDropdownIconRequired, isLoading, isCursorHidden } = props;

    // Overview Detail
    let accountOverview = "";
    if (func_validation.isArrayNotEmpty(accountOverviewArray)) {
        accountOverview = accountOverviewArray.map((accountDetail, idx) => {
            let label = func_validation.getObjectPropertyValueNotNullUndefined(accountDetail, "label","-");
            let value = func_validation.getObjectPropertyValueNotNullUndefined(accountDetail, "value", "-");

            return (
                <div key={idx} className={"accountOverviewDropdown-overviewSpecificDetail"}>
                    <div className={"accountOverviewDropdown-overviewSpecificDetail-label"}>
                        {label}
                    </div>
                    <div className={"accountOverviewDropdown-overviewSpecificDetail-value " +
                                    (isLoading? "accountOverviewDropdown-overviewSpecificDetail-value_shimmer ":"")}>
                        <div className={isLoading? "invisible":""}>{value}</div>
                    </div>
                </div>
            );
        })
    }

    // Dropdown Detail
    let dropdownDetail = "";
    if (func_validation.isArrayNotEmpty(dropdownDetailArray)) {
        dropdownDetail = dropdownDetailArray.map((accountDetail, idx) => {
            let label = func_validation.getObjectPropertyValue(accountDetail, "label", "-");
            let value = func_validation.getObjectPropertyValue(accountDetail, "value", "-");

            return (
                <div key={idx} className={"accountOverviewDropdown-dropdownDetail-item"}>
                    <div className={"accountOverviewDropdown-item-label"}>
                        {label}
                    </div>
                    <div className={"accountOverviewDropdown-item-value"}>
                        {value}
                    </div>
                </div>
            );
        });
    }

    return (
       <DropdownLayout
           className={"accountOverviewDropdown"}
           overviewClassName={"accountOverviewDropdown-overview"}
           overviewDisplay={(
               <div className={"d-flex align-items-center"}>
                   {/* Account Icon */}
                   <div className={"accountOverviewDropdown-accountIcon"}>
                       <img
                           src={userIcon}
                           alt={"User Icon"}
                       />
                   </div>

                   {/* Account Overview */}
                   <div className={"accountOverviewDropdown-overviewDetail d-flex align-items-center flex-wrap"}>
                       {accountOverview}
                   </div>
               </div>
           )}

           dropdownDetailClassName={"accountOverviewDropdown-dropdownDetail"}
           dropdownDetailDisplay={dropdownDetail}
           isDropdownIconRequired={isDropdownIconRequired}
           isCursorHidden={isCursorHidden}
       />
    );
}